enum FeatureFlags {
  SupportRedirect = 'support-redirect',
}

export default FeatureFlags;
